import { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import {
  clearComponentByIdMultilingual,
  getComponentByIdMultilingual,
  useContentSelector,
} from '@wajeez-web/stores/content';
import { useNavigate } from 'react-router-dom';

import { ComponentForm } from '../components/ComponentForm';
import { useGetComponentByIdMultilingual } from '@wajeez-web/components/helpers';

export const EditComponentsComponentPage = () => {
  const { componentId } = useParams<{
    componentId: string;
  }>();

  const navigate = useNavigate();

  const { data: componentDetailsMultilingualData } =
    useGetComponentByIdMultilingual();

  useEffect(() => {
    componentId && getComponentByIdMultilingual(componentId);

    return () => {
      clearComponentByIdMultilingual();
    };
  }, [componentId]);

  return (
    <div>
      <ComponentForm
        type="Edit"
        onSubmit={() => {
          navigate(`/components`);
        }}
        onItemTemplateCloneSaveAndEdit={(itemTemplateId) => {
          navigate(`/components/${itemTemplateId}/edit`);
        }}
        onItemTemplateEditButtonClick={(itemTemplateId) => {
          navigate(`/components/${itemTemplateId}/edit`);
        }}
        componentTypeId={componentDetailsMultilingualData?.typeId?.toString()}
        onCancel={() => {
          navigate(`/components`);
        }}
      />
    </div>
  );
};
